<template>
<div>
    <b-card
    class="mb-50"
    no-body
  >
    <div class="m-1">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="payout-filter-select"
              placeholder="Select Status"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>
          </div>
        </b-col>
      </b-row>
    </div>
    </b-card>

  <b-card
    no-body
  >
    <b-table
      ref="refPayoutListTable"
      :items="fetchPayouts"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      :busy.sync="isBusy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >
    <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner
          label="Loading..."
          class="align-middle">
          </b-spinner>
          <strong class=" ml-2">Fetching...</strong>
        </div>
      </template>
      <!-- Column: Id -->
      <template #cell(msisdn)="data">
        <span
        class="font-weight-bold d-block text-nowrap">
        {{ data.item.msisdn }}   
        </span>
      </template>

      <!-- Column: Payout Status -->
      <template #cell(status)="data">
        <b-avatar
          :id="`payout-row-${data.item.id}`"
          size="32"
          :variant="`light-${resolvePayoutStatusVariantAndIcon(data.item.status).variant}`"
        >
          <feather-icon
            :icon="resolvePayoutStatusVariantAndIcon(data.item.status).icon"
          />
        </b-avatar>
        <b-tooltip
          :target="`payout-row-${data.item.id}`"
          placement="top"
        >
          <p class="mb-0">
            Status: {{ data.item.status }}
          </p>
          <p class="mb-0">
            Amount: {{ data.item.amount }}
          </p>
          <p class="mb-0">
            Transaction Time: {{ data.item.created_at }}
          </p>
        </b-tooltip>
      </template>
      <!-- Column: Balance -->
      <template #cell(amount)="data">
        <span class="text-nowrap">
          {{ Number(data.item.amount).toLocaleString() }}
              <sup>KES</sup>
        </span>
      </template>
      <!-- Column: Balance -->
      <template #cell(mpesa_transaction_id)="data">
        <span class="text-nowrap">
          {{ data.item.mpesa_transaction_id }}
        </span>
      </template>
      
      <!-- Column: Balance -->
      <template #cell(details)="data">
        <span class="text-nowrap">
          {{ data.item.details }}
        </span>
      </template>
      <!-- Column: Balance -->
      <template #cell(created_at)="data">
        <span class="text-nowrap">
          {{ data.item.created_at }}
        </span>
      </template>
      <!-- Column: Balance -->
      <template #cell(method)="data">
        <span class="text-nowrap">
          {{ data.item.method }}
        </span>
      </template>
      
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalPayouts"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>
</div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BAvatar,
  BPagination, BTooltip, BButton, BBadge,BSpinner,
} from 'bootstrap-vue'
// import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import usePayoutsList from './usePayoutList'

import paymentsStoreModule from '../paymentsStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    // BMedia,
    BAvatar,
    BBadge,
    BPagination,
    BTooltip,
    BButton,
    BSpinner,

    vSelect,
  },
  directives: {
    Ripple,
  },
  setup() {
    const PAYMENT_APP_STORE_MODULE_NAME = 'payments'

    // Register module
    if (!store.hasModule(PAYMENT_APP_STORE_MODULE_NAME)) store.registerModule(PAYMENT_APP_STORE_MODULE_NAME, paymentsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PAYMENT_APP_STORE_MODULE_NAME)) store.unregisterModule(PAYMENT_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      'Pending',
      'Processed',
      'Failed',
    ]

    const {
      fetchPayouts,
      tableColumns,
      perPage,
      currentPage,
      totalPayouts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPayoutListTable,

      statusFilter,

      refetchData,
      isBusy,

      resolvePayoutStatusVariantAndIcon,
    } = usePayoutsList()

    return {
      fetchPayouts,
      tableColumns,
      perPage,
      currentPage,
      totalPayouts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPayoutListTable,

      statusFilter,

      refetchData,
      isBusy,

      statusOptions,
      resolvePayoutStatusVariantAndIcon,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
/* Busy table styling */
table.b-table[aria-busy='true'] {
  opacity: 0.6;
}

.payout-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
